/**
 * Australian state-to-timezone mapping and timezone resolution.
 *
 * Australian timezones:
 *   AEST (UTC+10, DST Oct-Apr): NSW, VIC, TAS, ACT
 *   AEST (UTC+10, NO DST):      QLD
 *   ACST (UTC+9:30, DST):       SA
 *   ACST (UTC+9:30, NO DST):    NT
 *   AWST (UTC+8, NO DST):       WA
 */

/** Default timezone — used when no facility/tenant context is available */
export const DEFAULT_TIMEZONE = 'Australia/Sydney';

/** Maps Australian state codes to their canonical IANA timezone */
export const STATE_TO_TIMEZONE: Record<string, string> = {
  NSW: 'Australia/Sydney',
  VIC: 'Australia/Melbourne',
  QLD: 'Australia/Brisbane',
  SA: 'Australia/Adelaide',
  WA: 'Australia/Perth',
  TAS: 'Australia/Hobart',
  ACT: 'Australia/Sydney',
  NT: 'Australia/Darwin',
};

/**
 * Resolves the correct IANA timezone string from available context.
 *
 * Resolution chain (first non-null wins):
 *   1. Explicit facility timezone (from facilities.timezone column)
 *   2. Facility state → STATE_TO_TIMEZONE lookup
 *   3. Tenant-level timezone (from tenant_configs.timezone column)
 *   4. DEFAULT_TIMEZONE ('Australia/Sydney')
 */
export function resolveTimezone(opts?: {
  facilityTimezone?: string | null;
  facilityState?: string | null;
  tenantTimezone?: string | null;
}): string {
  if (opts?.facilityTimezone) return opts.facilityTimezone;
  if (opts?.facilityState) {
    const tz = STATE_TO_TIMEZONE[opts.facilityState];
    if (tz) return tz;
  }
  if (opts?.tenantTimezone) return opts.tenantTimezone;
  return DEFAULT_TIMEZONE;
}
